import TabEvent from '../../components/RequestTab.vue'
import PlaceSelect from '../LocationPage.vue'
import SmetaTab from '../../components/SmetaTabRequest.vue'
import http from '@/http-common'
import InputGroupForm from '../../components/InputGroupForm.vue'
import Title from "@/components/TitlePage.vue";

export default {
    name: 'RequestEvent',
    components: {Title, TabEvent, PlaceSelect, SmetaTab, InputGroupForm},
    props: {
        isCalled: {
            type: Boolean,
            default: false,
        },
        columns: {
            type: Array,
            default: () => [
                {key:'stateRequestName', label: 'Состояние', sortable: true, tdClass: "tdClass"},
                {key: 'dateEvent', label: 'Дата проведения'},
                {key:'nameEvent', label: 'Наименование мероприятия', sortable: true},
                {key:'federation', label: 'Федерация', sortable: true},
                {key:'organization', label: 'ЕКП', sortable: true},
                {key:'ekpType', label: 'Вид ЕКП', sortable: true},
                {key:'eventKind', label: 'Статус', sortable: true},
                {key:'location', label: 'Место проведения', sortable: true},
                {key:'jobKind', label: 'Вид работ', sortable: true},
                {key:'sportKind', label: 'Раздел ЕКП', sortable: true},
                {key:'ageKind', label: 'Возрастная категория', sortable: true},
                {key:'count_people', label: 'Кол-во участников', sortable: true},
                {key:'summ', label: 'Сумма ЕКП', sortable: true},
                {key: 'edit_field', label: '', firstClass: 'width10', sortable: false}
            ],
        }
    },
    data(){
        return {
            items: [],
            isBusy: false,
            captionTable: 'Заявки на мероприятия',
            selectedItem: {
                name: '',
                code: '',
                dateBegin: null
            },
            captionSpr: {
                name: 'Заявки',
                nameR: 'Заявку'
            },
            urls: {
                save: '/request/saveEkp',
                delete: '/request/setdelete',
            },
            modalEditOpened: false,
            modalSetDelete: false,
            modalSmetaOpened: false,
            validValue: {
                org: true,
                eventkind: true, // вид ЕКП
                nameEvent: true, // наименование мероприятия
                federation: true, // федерация
                sportkind: true, // раздел ЕКП
                location: true, // место проведения
                jobkind: true, // вид работ
                ekpType: true, // вид ЕКП
                ageKind: true, // возрастная категория
                summaEkp: true, // сумма
                summaAll: true,
                countPeople: true, // кол-во участников
                form: true
            },
            orgs: [],
            loadData: {
                loadOrgs: true,
                loadEventKind: true,
                loadJobKind: true,
                loadAgeKind: true
            },
            dat1: null,
            dat2: null,
            eventkindList: [],
            modalPlaceOpened: false,
            columnsPlace: [
                {key: 'nameObj', label: 'Наименование объекта'},
                {key: 'locality', label: 'Населенный пункт'},
                {key: 'district', label: 'Район'},
                {key: 'adress', label: 'Адрес'}
            ],
            selectedPlace: null,
            jobkindList: [],
            kindList: [],
            ageKindList: [],
            statusList: [],
            fedList: [],
            filter: {
                selectedOrgId: null,
                selectedEkpTypeId: null,
                selectedStatusId: null,
                selectedFedId: null,
                other: null},
            showFilter: false,
            filteredItems: [],
            excel_fields: [
                {field:'stateRequestName', label: 'Состояние'},
                {field:'dateEvent', label: 'Дата проведения'},
                {field:'nameEvent', label: 'Наименование мероприятия'},
                {field:'organization', label: 'ЕКП'},
                {field:'ekpType', label: 'Вид ЕКП', dataFormat: this.heldFormat},
                {field:'eventKind', label: 'Статус'},
                {field:'location', label: 'Место проведения'},
                {field:'jobKind', label: 'Вид работ'},
                {field:'sportKind', label: 'Раздел ЕКП'},
                {field:'ageKind', label: 'Возрастная категория'},
                {field:'count_people', label: 'Кол-во участников'},
                {field:'summ', label: 'Сумма ЕКП'}
            ],
            fileName: 'ЕКП заявки',
            ekpTypeList: [],
            summaSmeta: 0,
            limitFed: 0,
            summRecord: 0,
            smeta: {
                ekp_id: null,
                details: []
            }
        }
    },
    created() {
        var dat = new Date();
        var datAutumn = new Date(dat.getFullYear() + '.09.01')
        if (dat > datAutumn) {
            this.dat1 = (dat.getFullYear() + 1).toString() + "-01-01";
            this.dat2 = (dat.getFullYear() + 1).toString() + "-12-31";
        } else {
            this.dat1 = (dat.getFullYear()).toString() + "-01-01";
            this.dat2 = (dat.getFullYear()).toString() + "-12-31";
        }
        this.loadStatusEkp()
        this.loadOrgs()
        this.loadEkpTypes()
        this.loadFederations();
    },
    watch: {
        loadData: {
            handler(val){
                if (val.loadOrgs === false && this.orgs.length>0) {
                    // this.filter.selectedOrgId = this.orgs[0].value
                    this.loadItems();
                }
                if (val.loadEventKind === false &&
                    val.loadJobKind === false && val.loadAgeKind === false) {
                    this.modalEditOpened = true
                }
            },
            deep: true
        },
        // selectedItem: {
        //     handler(val){
        //         this.getSummSmeta(val)
        //     }
        // }
    },
    methods: {
        heldFormat(value) {
            if (value === true)
                return 'Проведен'
            else
                return ''
        },
        // getSummSmeta(val) {
        //     if (val)
        //         this.summaSmeta = val.summaSmeta
        //     else
        //         this.summaSmeta = 0
        // },
        loadEkpTypes() {
            var vm = this;
            vm.ekpTypeList = []
            var opt = {value: null, text: '-- Выберите вид ЕКП --'}
            vm.ekpTypeList.push(opt);
            http.get('/workkind/EKP_TYPE/list')
                .then((response) => {
                    response.data.forEach(function (x) {
                        var obj = {value: x.id, text: x.name}
                        vm.ekpTypeList.push(obj);
                    })
                })
                .catch((error) => console.log(error.message));
        },
        getFormattedDate(date) {
            let year = date.getFullYear();
            let month = (1 + date.getMonth()).toString().padStart(2, '0');
            let day = date.getDate().toString().padStart(2, '0');

            return year + '-' + month + '-' + day;
        },
        loadItems() {
            var vm = this;
            var filter = ''
            this.isBusy = true;
            if (this.filter.selectedOrgId && this.filter.selectedOrgId>0)
                filter += '&org_id=' + this.filter.selectedOrgId
            if (this.filter.selectedFedId && this.filter.selectedFedId>0)
                filter += '&fed_id=' + this.filter.selectedFedId
            if (this.filter.selectedEkpTypeId && this.filter.selectedEkpTypeId>0)
                filter += '&ekptype_id=' + this.filter.selectedEkpTypeId
            if (this.dat1)
                filter += '&dat1='+this.dat1;
            if (this.dat2)
                filter += '&dat2='+this.dat2;
            http.get('/request/listAll?' + filter)
                .then((response) => {
                    vm.items = response.data;
                    vm.isBusy = false
                    vm.showFilter = false
                    vm.onFiltered(vm.items)
                })
                .catch((error) => console.log(error.message))
        },
        loadFederations() {
            var vm = this;
            vm.fedList = []
            var opt = {value: null, text: '-- Все --'}
            vm.fedList.push(opt);
            http.get('/federation/list')
                .then((response) => {
                    //vm.fedList = response.data;
                    response.data.forEach(function (x) {
                        var obj = {}
                        obj.value = x.id;
                        obj.text = x.shortName;
                        vm.fedList.push(obj);
                    })
                })
                .catch((error) => console.log(error.response.data));
        },
        clearFilter() {
            for (var key in this.filter) {
                if (typeof this.filter[key] === 'string') {
                    this.filter[key] = null
                } else if (typeof this.filter[key] === 'array') {
                    this.filter[key] = []
                } else {
                    this.filter[key] = null
                }
            }
            this.filter.selectedOrgId = this.orgs[0].value
            this.loadItems()
        },
        showFilterDialog() {
            this.showFilter = !this.showFilter
        },
        showEditDialog() {
            this.loadEventKindList()
            this.loadJobKind()
            this.loadSportKind()
            this.loadAgeKind()
            //this.getSummSmeta(this.selectedItem)
            //this.loadEkpTypes()
            if (this.selectedItem.id == null) {
                this.selectedItem.dateBegin = this.getFormattedDate(new Date());
                this.selectedItem.dateEnd = this.getFormattedDate(new Date());
            }
        },
        loadOrgs() {
            var vm = this;
            this.loadData.loadOrgs = true;
            vm.orgs = []
            // var opt = {value: null, text: '-- Все --'}
            // vm.orgs.push(opt);
            http.get('/org/list')
                .then((response) => {
                    response.data.forEach( function (x) {
                        var rec = {}
                        rec.value = x.id;
                        rec.text = x.shortName;
                        vm.orgs.push(rec);
                    })
                    vm.loadData.loadOrgs = false
                    this.filter.selectedOrgId = this.orgs[0].value
                })
                .catch((error) => console.log(error.message))
                // .finally(() =>  vm.loadData.loadOrgs = false);
        },
        loadEventKindList() {
            var vm = this;
            this.loadData.loadEventKind = true;
            vm.eventkindList = []
            var opt = {value: null, text: '-- Выберите статус мероприятия --'}
            vm.eventkindList.push(opt);
            http.get('/eventkind/list')
                .then((response) => {
                    response.data.forEach( function (x) {
                        var rec = {}
                        rec.value = x.id;
                        rec.text = x.nameKind;
                        vm.eventkindList.push(rec);
                    })
                    vm.loadData.loadEventKind = false
                })
                .catch((error) => console.log(error.message))
            // .finally(() =>  vm.loadData.loadOrgs = false);
        },
        loadSportKind() {
            var vm = this;
            this.loadData.loadSportKind = true;
            vm.kindList = []
            var opt = {value: null, text: '-- Выберите раздел ЕКП --', disabled: true}
            vm.kindList.push(opt);
            http.get('/sportkind/list')
                .then((response) => {
                    response.data.forEach( function (x) {
                        var rec = {}
                        rec.value = x.id;
                        rec.text = x.name;
                        vm.kindList.push(rec);
                    })
                    vm.loadData.loadSportKind = false
                })
                .catch((error) => console.log(error.message))
            // .finally(() =>  vm.loadData.loadOrgs = false);
        },
        loadJobKind() {
            var vm = this;
            this.loadData.loadJobKind = true;
            vm.jobkindList = []
            var opt = {value: null, text: '-- Выберите вид работ --', disabled: true}
            vm.jobkindList.push(opt);
            http.get('/workkind/JOB_KIND/list')
                .then((response) => {
                    response.data.forEach( function (x) {
                        var rec = {}
                        rec.value = x.id;
                        rec.text = x.shortName;
                        vm.jobkindList.push(rec);
                    })
                    vm.loadData.loadJobKind = false
                })
                .catch((error) => console.log(error.message))
            // .finally(() =>  vm.loadData.loadOrgs = false);
        },
        loadAgeKind() {
            var vm = this;
            this.loadData.loadAgeKind = true;
            vm.ageKindList = []
            var opt = {value: null, text: '-- Выберите возрастную категорию --', disabled: true}
            vm.ageKindList.push(opt);
            http.get('/workkind/AGE_KIND/list')
                .then((response) => {
                    response.data.forEach( function (x) {
                        var rec = {}
                        rec.value = x.id;
                        rec.text = x.shortName;
                        vm.ageKindList.push(rec);
                    })
                    vm.loadData.loadAgeKind = false
                })
                .catch((error) => console.log(error.message))
            // .finally(() =>  vm.loadData.loadOrgs = false);
        },
        loadStatusEkp() {
            var vm = this;
            vm.statusList = []
            var opt = {value: null, text: '-- Все --'}
            vm.statusList.push(opt);
            http.get('/ekp/statusekp')
                .then((response) => {
                    response.data.forEach( function (x) {
                        vm.statusList.push(x);
                    })
                })
                .catch((error) => console.log(error.message))
        },
        checkForm() {
            for (var key in this.validValue) {
                this.validValue[key] = true;
            }

            if (!this.selectedItem.organizationId || this.selectedItem.organizationId <= 0) {
                this.validValue.org = false;
                this.validValue.form = false;
            }

            if (!this.selectedItem.nameEvent || this.selectedItem.nameEvent === '') {
                this.validValue.nameEvent = false;
                this.validValue.form = false;
            }

            if (!this.selectedItem.eventKindId || this.selectedItem.eventKindId <= 0) {
                this.validValue.eventkind = false;
                this.validValue.form = false;
            }

            if (!this.selectedItem.locationId || this.selectedItem.locationId <= 0) {
                this.validValue.location = false;
                this.validValue.form = false;
            }

            if (!this.selectedItem.sportKindId || this.selectedItem.sportKindId <= 0) {
                this.validValue.sportkind = false;
                this.validValue.form = false;
            }

            if (!this.selectedItem.ekpTypeId || this.selectedItem.ekpTypeId <= 0) {
                this.validValue.ekpType = false;
                this.validValue.form = false;
            }

            if (!this.selectedItem.jobKindId || this.selectedItem.jobKindId <= 0) {
                this.validValue.jobkind = false;
                this.validValue.form = false;
            }

            if (!this.selectedItem.ageKindId || this.selectedItem.ageKindId <= 0) {
                this.validValue.ageKind = false;
                this.validValue.form = false;
            }

            if (!this.selectedItem.count_people || this.selectedItem.count_people < 0) {
                this.validValue.countPeople = false;
                this.validValue.form = false;
            }

            if (!this.selectedItem.summ || this.selectedItem.summ < 0) {
                this.validValue.summEkp = false;
                this.validValue.form = false;
            }
        },
        saveItem() {
            this.checkForm();
            if (this.validValue.form) {
                this.modalEditOpened = false;
                if (this.smeta.details.length > 0)
                    this.selectedItem.smeta = this.smeta;
                this.$refs.TabEvent.save(this.selectedItem);
            }
        },
        checkDate1() {
            if (this.dat1 > this.dat2)
                this.dat2 = this.dat1
        },
        checkDate2() {
            if (this.dat1 > this.dat2) {
                this.dat1 = this.dat2
            }
        },
        checkDateEdit() {
            if (this.selectedItem.dateBegin > this.selectedItem.dateEnd)
                this.selectedItem.dateEnd = this.selectedItem.dateBegin
        },
        validate_date(value) {
            var arrD = value.split("-"); // yyyy-mm-dd
            arrD[1] -= 1;
            var sTmp = arrD[0] +'-'+ arrD[1]+'-'+ arrD[2];
            return new Date(sTmp) !== 'Invalid Date';
        },
        showPlaceDialog() {
            this.modalPlaceOpened = !this.modalPlaceOpened;
        },
        selectPlace() {
            this.selectedItem.location = this.selectedPlace.nameObj;
            this.selectedItem.locationId = this.selectedPlace.id;
            this.modalPlaceOpened = false;
        },
        deleteItem() {
            this.$refs.TabEvent.showConfirmDlg();
        },
        onFiltered(filteredItems) {
            this.filteredItems = filteredItems;
            this.setSummRecord(filteredItems)
        },
        showSmeta() {
            this.loadSmeta();
        },
        // showSmeta() {
        //     //this.getSummSmeta(this.selectedItem);
        //     this.modalSmetaOpened = !this.modalSmetaOpened;
        // },
        saveSmeta() {
            this.$refs.SmetaTab.saveSmeta();
            // this.modalSmetaOpened = !this.modalSmetaOpened;
            // this.getSummSmeta(this.selectedItem);
        },
        closeSmetaModal() {
            this.modalSmetaOpened = !this.modalSmetaOpened;
            this.selectedItem.summaSmeta = this.smeta.summaSmeta
            //this.getSummSmeta(this.selectedItem);
        },
        updateLimit() {
            var vm = this
            var year = new Date().getFullYear();
            var orgId = this.filter.selectedOrgId;
            var fedId = this.filter.selectedFedId;
            var ekpTypeId = this.filter.selectedEkpTypeId;
            if (orgId>0 && fedId>0 && ekpTypeId>0 && year>0) {
                http.get('/limit/' + year + '/' + orgId + '/' + fedId + '?ekptype_id=' + ekpTypeId)
                    .then((response) => {
                        vm.limitFed = response.data.summLimit;
                    })
                    .catch((error) => console.log(error.message))
            } else {
                vm.limitFed = 0;
            }
        },
        setSummRecord(filteredItems) {
            var summ = 0;
            filteredItems.forEach(function (x) {
                summ += x.summ;
            })
            this.summRecord = summ;
        },
        loadSmeta() {
            var vm = this;
            if (this.selectedItem.id && this.selectedItem.id > 0) {
                http.get("/ekp/smeta/" + this.selectedItem.id)
                    .then((res) => {
                        vm.smeta = res.data
                        this.modalSmetaOpened = !this.modalSmetaOpened;
                    }).catch(function (error) {
                    alert("Ошибка!!!")
                })
            } else
                this.modalSmetaOpened = !this.modalSmetaOpened;
        }
    }
}
